import React, { useState } from "react";
import jsDig from "utils/jsDig";
import LiteMetricTable from "dashboards/lite/LiteMetricTable";
import LiteLineChart from "dashboards/lite/LiteLineChart";
import LiteRefresh from "dashboards/lite/LiteRefresh";
import ObjectivePicker from "dashboards/lite/ObjectivePicker";
import DashboardOptions from "dashboards/lite/DashboardOptions";
import { capitalize } from "lodash";
import LiteExportPDF from 'utils/LiteExportPDF';
import YearPicker from "dashboards/lite/YearPicker";

export default function OtherDashboard(props) {
  console.log(props)
  const metricTableDimensions = jsDig(["overall", "sessions", "direct"], props.table_data) ? Object.keys(jsDig(["overall", "sessions", "direct"], props.table_data)) : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", "YTD", "Total"];
  // Convert utc date to local time in this format 12:30 PM, 12/31/2021
  const lastDataPull = new Date(jsDig(["last_data_pull"], props)).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    month: "numeric",
    day: "numeric",
    year: "numeric",
  });

  // Read the 'year' query param if it exists
  const urlParams = new URLSearchParams(window.location.search);
  const queryYear = parseInt(urlParams.get("year"), 10);

  // If queryYear is not a valid number, use the current year, else use queryYear
  const thisYear = isNaN(queryYear) ? new Date().getFullYear() : queryYear;
  const lastYear = thisYear - 1;

  let mainIcon = require("images/lite/icons/other.svg");
  mainIcon = <div className="other-icon active dashboard-icon"><img className="dashboard-icon-2" src={`/datapulse${mainIcon}`} /></div>

  const [dashboardObjective, setDashboardObjective] = useState(props.client_account.dashboard_objective ? props.client_account.dashboard_objective : "sales");
  let revenueOrConversions = dashboardObjective == "sales" ? "revenue" : "conversions";
  let roasOrCpa = dashboardObjective == "sales" ? "roas" : "cpa";

  const dashboardType = "other"
  const [dashboardOptions, setDashboardOptions] = useState(props.client_account.dashboard_options ? props.client_account.dashboard_options : {});

  return (
    <>
      <div className="lite-dashboard other-dashboard">
        <div className="dashboard-header">
          <div className="dashboard-header-left">
            {mainIcon}
            <h1>Other Dashboard</h1>
          </div>
          <div className="dashboard-header-center">
          </div>
          <div className="dashboard-header-right flex-end">
            <div className="most-recent-refresh">
              <small id="most-recent-refresh">Last refresh: {props.last_data_pull ? lastDataPull : "Never"}</small>
            </div>
            <div className="objective-refresh-container">
              <YearPicker/>
              {/* <ObjectivePicker setDashboardObjective={setDashboardObjective} dashboardObjective={dashboardObjective} /> */}
              {props.user_is_employee && (
                <LiteRefresh refreshPreference={props.default_refresh_preference} currentDashboard={"other"} accountId={props.client_account.id} alreadyPulling={props.current_data_pulls} />
              )}
              <DashboardOptions dashboardOptions={dashboardOptions} setDashboardOptions={setDashboardOptions} dashboardType={dashboardType} accountId={props.client_account.id} />
              <LiteExportPDF companyName={props.company_name} dashName="Other" />
            </div>
          </div>
        </div>
        <div className="dashboard-body">
          <div className="lite-dashboard-section">
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "affiliates", "sessions", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "affiliates", "sessions", "labels"], props.chart_data)}
                data={jsDig(["overall", "affiliates", "sessions", "data"], props.chart_data)}
                chartName="Affiliate Traffic L60D"
                metric="sessions"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "direct", "sessions", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "direct", "sessions", "labels"], props.chart_data)}
                data={jsDig(["overall", "direct", "sessions", "data"], props.chart_data)}
                chartName="Direct Traffic L60D"
                metric="sessions"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "referral", "sessions", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "referral", "sessions", "labels"], props.chart_data)}
                data={jsDig(["overall", "referral", "sessions", "data"], props.chart_data)}
                chartName="Referral Traffic L60D"
                metric="sessions"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
          </div>

          <div className="lite-dashboard-section">
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "audio", "sessions", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "audio", "sessions", "labels"], props.chart_data)}
                data={jsDig(["overall", "audio", "sessions", "data"], props.chart_data)}
                chartName="Audio Traffic L60D"
                metric="sessions"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "mobile_push_notifications", "sessions", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "mobile_push_notifications", "sessions", "labels"], props.chart_data)}
                data={jsDig(["overall", "mobile_push_notifications", "sessions", "data"], props.chart_data)}
                chartName="Mobile Push Notification Traffic L60D"
                metric="sessions"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "sms", "sessions", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "sms", "sessions", "labels"], props.chart_data)}
                data={jsDig(["overall", "sms", "sessions", "data"], props.chart_data)}
                chartName="SMS Traffic L60D"
                metric="sessions"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
          </div>

          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["affiliates", "direct", "referral", "audio", "mobile_push_notifications", "sms"]}
                subHeaderOrder={[thisYear, "Y/Y"]}
                data={jsDig(["overall", "total", "sessions"], props.table_data)}
                tableName="Monthly View"
                skipPrev={true}
                dimensions={metricTableDimensions}
              />
            </div>
          </div>

          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["affiliates", "direct", "referral", "audio", "mobile_push_notifications", "sms"]}
                subHeaderOrder={[thisYear, "Y/Y"]}
                data={jsDig(["overall", "l60", "sessions"], props.table_data)}
                tableName="Daily View L60D"
                skipPrev={true}
                dimensions={jsDig(["overall", "l60", "sessions", "direct"], props.table_data) ? Object.keys(jsDig(["overall", "l60", "sessions", "direct"], props.table_data)) : []}
                topSummaryRow={{dimension: "L7D >", data: jsDig(["overall", "l7", "sessions"], props.table_data)}}
                collapsed={true}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
